export default __webpack_public_path__ + "static/media/2_0014.0958585c.webp";